
export const sortProductByName = (defaultProducts: any) => {
    if (defaultProducts.length > 0) {
      return [...defaultProducts]?.sort((a: any, b: any) => {
        const nameA = a?.name ?? "";
        const nameB = b?.name ?? "";
        return nameA.localeCompare(nameB);
      });
    }
    return [];
  };
  